var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 11.625H9.75C8.71447 11.625 7.875 12.4645 7.875 13.5V21C7.875 22.0355 8.71447 22.875 9.75 22.875H22.25C23.2855 22.875 24.125 22.0355 24.125 21V13.5C24.125 12.4645 23.2855 11.625 22.25 11.625Z",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0687 11.6251V10.4532C22.0687 10.1658 22.0051 9.88195 21.8827 9.62191C21.7603 9.36187 21.582 9.13206 21.3605 8.94886C21.139 8.76567 20.8798 8.63362 20.6015 8.56212C20.3231 8.49063 20.0323 8.48146 19.75 8.53526L9.4625 10.2911C9.01575 10.3763 8.61272 10.6146 8.32291 10.9651C8.0331 11.3156 7.87469 11.7563 7.875 12.211V14.1251",
    stroke: "#1ED760",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.375 18.5C20.1278 18.5 19.8861 18.4267 19.6805 18.2893C19.475 18.152 19.3148 17.9568 19.2202 17.7284C19.1255 17.4999 19.1008 17.2486 19.149 17.0061C19.1973 16.7637 19.3163 16.5409 19.4911 16.3661C19.6659 16.1913 19.8887 16.0723 20.1311 16.024C20.3736 15.9758 20.6249 16.0005 20.8534 16.0952C21.0818 16.1898 21.277 16.35 21.4143 16.5555C21.5517 16.7611 21.625 17.0028 21.625 17.25C21.625 17.5815 21.4933 17.8995 21.2589 18.1339C21.0245 18.3683 20.7065 18.5 20.375 18.5Z",
    fill: "#1ED760"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoney);
export default __webpack_public_path__ + "static/media/ic_money.641a2303c3f6d3e9b996aa2700ede818.svg";
export { ForwardRef as ReactComponent };